import React from 'react';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';

export default function BillingSummaryCard() {
  return (
    <Card className="shadow-sm mb-4">
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Billing summary</h5>
      </CardHeader>
      <CardBody>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Total due</span>
          <span className="fw-medium">$0.00</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Past due</span>
          <span className="fw-medium">$0.00</span>
        </div>
        {/* <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Recent charges</span>
          <span className="fw-medium">$60.00</span>
        </div>
        <div className="d-flex justify-content-between">
          <span className="text-muted">Recent transactions</span>
          <span className="fw-medium">$60.00</span>
        </div> */}
      </CardBody>
    </Card>
  );
}
